import HeaderButton from "../components/utils/button/HeaderButton";
import { TextField } from "@material-ui/core";
import { fallbackURL } from "../consts/FallbackURL";

export const refreshPage = () => window.location.reload()

export const lettersOnly = (value) => /^(?=s*[a-zA-Z])([a-zA-Z0-9\s]+)$/.test(value);

export const transformDNI = (text) => {
    if (!text) return '';
    text = text.toString();
    if (text.length === 5) return `${text.slice(0, 2)}.${text.slice(2)}`;
    if (text.length === 6) return `${text.slice(0, 3)}.${text.slice(3)}`;
    if (text.length === 7)
        return `${text.slice(0, 1)}.${text.slice(1, 4)}.${text.slice(4)}`;
    if (text.length === 8)
        return `${text.slice(0, 2)}.${text.slice(2, 5)}.${text.slice(5)}`;
    return text;
};
export const transformCVU = (text) => {
    if (!text) return '';
    text = text.toString();
    let text1= text.slice(0, 4)
    let text2= text.slice(4, 8)
    let text3= text.slice(8, 12)
    let text4= text.slice(12, 16)
    let text5= text.slice(16, 20)
    let text6= text.slice(20, 22)
    return (`${text1}${text2}${text3}${text4}${text5}${text6}`)
};

export const logout = () => {
    if (sessionStorage.getItem('hooliToken') && sessionStorage.getItem('sessionId')) {
        sessionStorage.removeItem('hooliToken');
        sessionStorage.removeItem('sessionId');
        window.location.assign(fallbackURL)
    }
};
export const transformNumber = (value) => {
    if (Number.isInteger(value)) {
        const result = new Intl.NumberFormat("es-ES").format(value) + ",00";
        if (result.length === 7)
            return `${result.substring(0, 1)}.${result.substring(1)}`;
        return result;
    }
    if (/\.\d$/.test(value.toString())) {
        const result = new Intl.NumberFormat("es-ES").format(value) + "0";
        if (result.length === 7)
            return `${result.substring(0, 1)}.${result.substring(1)}`;
        return result;
    }

    const result = new Intl.NumberFormat("es-ES").format(value);
    if (result.length === 7)
        return `${result.substring(0, 1)}.${result.substring(1)}`;
    return result;
};

export const formatNumber = (value) => {
    const convert = new Intl.NumberFormat("es-ES").format(value)
    if(convert === "NaN"){
        return value
    }
    return (convert)
};
export const handleResponse = (response, message, functions, toArray) => {
    const { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList } = functions

    if (response) {
        if (response.status.code === 1) {
            setSnackbarInfo({
                message,
                severity: 'success',
                open: true
            });
            setInRequest(false);
            setTimeout(() => {
                setSnackbarInfo({
                    message: '',
                    severity: 'success',
                    open: false
                });
                setIsOpen(false)
                toArray ? setSelected([]) : setSelected({ status: false, row: {} });
            }, 3000);
            updateList();
        }
        else {
            setSnackbarInfo({
                message: response.status.errmsg,
                severity: response.status.action === 'W' ? 'warning' : 'error',
                open: true
            });
            setInRequest(false);
            setTimeout(() => {
                setSnackbarInfo({
                    message: '',
                    severity: 'success',
                    open: false
                });
            }, 3000);
        }
    }
};

export const getGridProps = (columns, rows, row, setter, classes) => {
    return {
        localeText: {
            columnMenuLabel: "Menu",
            columnMenuShowColumns: "Mostrar columnas",
            columnMenuFilter: "Filtrar",
            columnMenuHideColumn: "Esconder",
            columnMenuUnsort: "Desordenar",
            columnMenuSortAsc: "Ordenar por ASC",
            columnMenuSortDesc: "Ordenar por DESC",
        },
        columns,
        rows,
        onRowClick: (data) => validateRowSelected(data, row, setter),
        className: classes.root,
        autoPageSize: true,
        hideFooterSelectedRowCount: true,
        disableMultipleSelection: true,
        pagination: true,
        showCellRightBorder: false,
        rowHeight: 36
    }
}

export const validateRowSelected = (newSelection, row, setSelected) => {
    if (row && row.id === newSelection.row.id) {
        newSelection.element.classList.remove('Mui-selected')
        return setSelected({ status: false, row: {} });
    }
    const newSelected = { status: true, row: newSelection.row }
    newSelection.element.classList.add('Mui-selected')
    return setSelected(newSelected)
};

export const generateButtons = (conditional, wordkey, handler, icons, id, updateList) => {
    return conditional ?
        <>
            <HeaderButton
                text={`Editar ${wordkey}`}
                icon={icons[0]}
                handleClick={handler}
                data={{ action: 'edit', procede: 'Editone' }}
                id={wordkey === 'End User' ? id : ''}
            />
            <HeaderButton
                text={`Eliminar ${wordkey}`}
                icon={icons[1]}
                handleClick={handler}
                data={{ action: 'delete', procede: 'Deleteone' }}
            />
        </>
        :
        <>
            <HeaderButton
                text={`Agregar ${wordkey}`}
                icon={icons[2]}
                handleClick={handler}
                data={{ action: 'add', procede: 'Addone' }}
            />
            <HeaderButton
                text={"Actualizar pagina"}
                icon={icons[3]}
                updateList={updateList}
            />
        </>
};

export const generateColumns = (titles) => {
    return titles.map((title) => {
        if (typeof title === 'object') {
            return {
                valueGetter: (params) => {
                    if (params.value === null || params.value === undefined)
                        return "";
                    if (title.format) {
                        switch (title.format) {
                            case 'number':
                                return formatNumber(params.value);
                            case 'date':
                                return transformDate(params.value);
                            /*case 'dateTime':
                                return formatNumber(params.value);*/
                            default:
                                return params.value;
                        }
                    }
                    return params.value;
                },
                ...title,
            };

        }

        return {
            field: title,
            headerName: title,
            valueGetter: (params) => {
                if ((params === null || params === undefined) && (params?.value === null || params?.value === undefined)) {
                    return "";
                }
                if (
                    (/Fecha/.test(title) ||
                        title === "Valido desde" ||
                        title === "Último cambio") &&
                    title !== "Fecha y hora"
                )
                    return transformDate(params.value || params);
                if (/Maximo|Minimo|Piso|Numero|Entrada|Salida|Grupo/.test(title))
                    return params;
                if (title === "DNI" || title === "Documento") return transformDNI(params.value || params);
                if (title === "CVU" ) return transformCVU(params.value || params);
                if (
                    /^\d(.*\d)?$/.test(params.value || params) &&
                    title !== "MAC" &&
                    title !== "Horario" &&
                    !/Fecha/.test(title) &&
                    title !== "Nombre" &&
                    title !== "Zona" &&
                    title !== "Acceso" &&
                    title !== "Identificación" &&
                    title !== "Firmantes internos" &&
                    title !== "Firmantes externos" &&
                    title !== "Celular" &&
                    title !== "Telefono" &&
                    title !== "CUIT origen" &&
                    title !== "Referencia"
                )
                    return transformNumber(params.value || params);
                return params.value || params;
            },
            sortComparator: (v1, v2, param1, param2) => {
                if (typeof v1 === "number")
                    return param1 - param2;
                if (
                    /\d{2}\/\d{2}\/\d{4}/.test(v1) &&
                    /\d{2}\/\d{2}\/\d{4}/.test(v2)
                ){
                    console.log(v2, v2.slice(6, 10)+  v2.slice(3,5) + v2.slice(0, 2) + v2.slice(10))
                    return (
                        parseInt(v1.slice(6, 10)+  v1.slice(3,5) + v1.slice(0, 2) + v1.slice(10)) -
                        parseInt(v2.slice(6, 10)+  v2.slice(3,5) + v2.slice(0, 2) + v2.slice(10))
                    );
                }

                let first = "";
                for (let i = 0; i < v1.length; i++) {
                    first +=
                        v1[i].toLowerCase().charCodeAt(0).toString(2) + " ";
                }
                let second = "";
                for (let i = 0; i < v2.length; i++) {
                    second +=
                        v2[i].toLowerCase().charCodeAt(0).toString(2) + " ";
                }
                return parseInt(first, 2) - parseInt(second, 2);
            },
            flex:
                (/Fecha/.test(title) &&
                    title !== "Fecha y hora" &&
                    title !== "Fecha " &&
                    title !== "Fecha Estado" &&
                    title !== "Fecha Creacion") ||
                    title === "Género"
                    ? 0
                    : 1,
            maxWidth: 300,
            width: /Fecha/.test(title)
                ? 160
                : title === "Género"
                    ? 100
                    : title === "Onboarding"
                        ? 100
                        : /Apellido y Nombre/.test(title)
                            ? 150
                            : 0,
        };
    });
};

export const retrieveData = async (credentials, setRows, getData, setData) => {
    if (setRows) setRows([])

    const data = await getData(credentials);
    setData(data)
};

export const transformDate = (str) => {
    if (!str) return '';
    const tieneHora = str.includes(' ') && str.includes(':');
    const [fechaParte, horaParte] = str.split(' ');
    const [año, mes, dia] = fechaParte.split('-');
    
    if (tieneHora) {
        return `${dia}/${mes}/${año} ${horaParte}`;
    } else {
        return `${dia}/${mes}/${año}`;
    }
}

export const generateDeleteInputs = (data, names, selected, titles) => {
    return <>
        {names.map((name, index) => {
            return <TextField
                key={data[`${name}`].label}
                label={data[`${name}`].label}
                disabled
                name={name}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                value={selected.row ? selected.row[`${titles[index]}`] : ''}
                fullWidth
            />
        })}
    </>
};

export const generateImage = (selected, path, src, alt) => {
    return (
        <div className="form__image-container">
            <img
                src={selected.row && selected.row[path] && !src ?
                    selected.row[path] : src ? `data:image/png;base64,${src}` : null}
                alt={alt}
                style={{ height: (selected.row && selected.row[path]) || src ? 90 : 0, maxWidth: 300 }}
            />
        </div>
    )
};

export const generateTextInput = (data, name, formik, openAlert) => {
    return (
        <TextField
            label={data[`${name}`].label}
            name={name}
            placeholder={data[`${name}`].placeholder}
            margin="normal"
            disabled={openAlert}
            value={formik.values[`${name}`]}
            onChange={formik.handleChange}
            error={formik.touched[`${name}`] && Boolean(formik.errors[`${name}`])}
            helperText={formik.touched[`${name}`] && formik.errors[`${name}`]}
            InputLabelProps={{ shrink: true }}
            fullWidth
        />
    )
};

export const generateDateInput = (data, name, formik, openAlert) => {
    return (
        <TextField
            label={data[`${name}`].label}
            name={name}
            margin="normal"
            type="date"
            disabled={openAlert}
            value={formik.values[`${name}`]}
            onChange={formik.handleChange}
            error={formik.touched[`${name}`] && Boolean(formik.errors[`${name}`])}
            helperText={formik.touched[`${name}`] && formik.errors[`${name}`]}
            InputLabelProps={{ shrink: true }}
            fullWidth
        />
    )
};

export const generateYesOrNoSelect = (data, name, formik, openAlert) => {
    return (
        <TextField
            label={data[`${name}`].label}
            name={name}
            placeholder={data[`${name}`].placeholder}
            margin="normal"
            select
            disabled={openAlert}
            SelectProps={{ native: true }}
            value={formik.values[`${name}`]}
            onChange={formik.handleChange}
            error={formik.touched[`${name}`] && Boolean(formik.errors[`${name}`])}
            helperText={formik.touched[`${name}`] && formik.errors[`${name}`]}
            fullWidth
        >
            <option value="Si">Si</option>
            <option value="No">No</option>
        </TextField>
    )
};

export const generateSelect = (data, name, formik, isDisabled, options, optionId, optionValue) => {
    return (
        <TextField
            label={data[`${name}`].label}
            name={name}
            placeholder={data[`${name}`].placeholder}
            margin="normal"
            select
            disabled={isDisabled}
            SelectProps={{ native: true }}
            value={formik.values[`${name}`]}
            onChange={formik.handleChange}
            error={formik.touched[`${name}`] && Boolean(formik.errors[`${name}`])}
            helperText={formik.touched[`${name}`] && formik.errors[`${name}`]}
            fullWidth
        >
            {options.map(option => {
                return <option
                    key={option[`${optionId}`]}
                    value={option[`${optionValue}`]}
                >
                    {option[`${optionValue}`]}
                </option>
            })}
        </TextField>
    )
};

export const handleImg = (e, setImg, readerHandler) => {
    let file = e.target.files[0]
    if (file) {
        setImg({ alt: file.name })
        const reader = new FileReader();
        reader.onload = readerHandler;
        reader.readAsBinaryString(file);
    }
};